export default __webpack_public_path__ + "static/media/facture_template.0d371192.pdf";